
import React from 'react';
import { Box } from 'grommet';

import PageFull from './PageFull';
import MapView from './map/MapView';
import Panels from './map/Panels';

import { MAP_PROJECT_DEFINIION } from './map/mapProject';

class MapPage extends React.Component {

    componentDidMount() {
        if (!this.props.map.definition) {
            this.props.initProject(MAP_PROJECT_DEFINIION);
        }
    }

    render() {
        return (
            <PageFull>
                <Box height="100%" direction="row">
                    <Box basis="2/3">
                        <MapView
                            map={this.props.map}
                            queryParams={this.props.queryParams}
                            changeView={this.props.changeView}
                            getInfo={this.props.getInfo}
                        />
                    </Box>
                    <Box basis="1/3" border={{side: 'left', color: '#cccccc'}}>
                        <Panels
                            map={this.props.map}
                            setLayerVisibility={this.props.setLayerVisibility}
                            clear={this.props.clear}
                            getLegend={this.props.getLegend}
                        />
                    </Box>
                </Box>
            </PageFull>
        );
    }
}

export default MapPage;
